import { AlertRibbon } from "@sebgroup/green-react";
import { useTranslation } from "react-i18next";

export interface ErrorAlertRibbonProps {
  errorMessage?: string;
}

function ErrorAlertRibbon({ errorMessage }: ErrorAlertRibbonProps) {
  const { t } = useTranslation();

  const error_somethingwrong = t("error_somethingwrong", {
    Error: errorMessage,
  });

  return (
    <AlertRibbon type="danger" isCloseable={false} aria-live="polite" role="alert">
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: error_somethingwrong,
        }}
      />
    </AlertRibbon>
  );
}

export default ErrorAlertRibbon;
